import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button/Button';

const navigateButtons = [
  {
    label: '送迎予約一覧',
    path: '/staff/offices',
  },
];

const StaffPage = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-4 text-[22px]">
      <div className="my-4 font-bold">本日の利用者</div>
      <div className="space-y-4">
        {navigateButtons.map((button) => (
          <Button
            key={button.path}
            className="w-full"
            variant="solid-fill"
            size="lg"
            type="button"
            onClick={() => navigate(button.path)}
          >
            {button.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default StaffPage;
